import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentTransportOrderStatusHistorySetInitialState,
  ShipmentTransportOrderStatusHistoryLoad,
} from './shipment-transport-order-status-history.actions';
import { ShipmentTransportOrderStatusHistoryService } from './shipment-transport-order-status-history.service';
import { ShipmentWaybillLoadHistoryData } from './shipment-transport-order-status-history.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderStatusHistoryStateModel {
  loadHistoryData: ShipmentWaybillLoadHistoryData[];
  loaded: boolean;
}

const initialState: ShipmentTransportOrderStatusHistoryStateModel = {
  loadHistoryData: [],
  loaded: false,
};

@State<ShipmentTransportOrderStatusHistoryStateModel>({
  name: 'shipmentTransportOrderStatusHistory',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderStatusHistoryState {
  constructor(
    private shipmentTransportOrderStatusHistoryService: ShipmentTransportOrderStatusHistoryService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getLoaded(state: ShipmentTransportOrderStatusHistoryStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getHistory(state: ShipmentTransportOrderStatusHistoryStateModel): ShipmentWaybillLoadHistoryData[] {
    return state.loadHistoryData;
  }

  @Action(ShipmentTransportOrderStatusHistoryLoad)
  getWaybillPlannedInfo(
    ctx: StateContext<ShipmentTransportOrderStatusHistoryStateModel>,
    { payload }: ShipmentTransportOrderStatusHistoryLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderStatusHistoryService.getStatusHistory(payload).pipe(
      map((loadHistoryData: ShipmentWaybillLoadHistoryData[]) => {
        ctx.patchState({ loadHistoryData, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderStatusHistorySetInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderStatusHistoryStateModel>): void {
    ctx.setState(initialState);
  }
}
